export const TEMPLATE_UTILITY_COST = 0.001;

export const TEMPLATE_MARKETING_COST = 0.0436;

export const TEMPLATE_CATEGORY = {
  MARKETING: "MARKETING",
  UTILITY: "UTILITY",
};

export const TEMPLATE_TYPE = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  VIDEO: "VIDEO",
  DOCUMENT: "DOCUMENT",
};

export const TEMPLATE_FILE_TYPE = {
  IMAGE: "image",
  VIDEO: "video",
  PDF: "pdf",
};

export const TEMPLATE_STATUS = {
  APPROVED: "accepted",
  PENDING: "submitted",
  REJECTED: "denied",
};

export const TEMPLATE_BUTTON_TYPE = {
  QUICK_REPLY: "QUICK_REPLY",
};

export const TEMPLATE_COMPONENT_TYPE = {
  BODY: "BODY",
  HEADER: "HEADER",
  FOOTER: "FOOTER",
  BUTTONS: "BUTTONS",
};

export const TEMPLATE_MAX_SIZE_FILE_MB = 1024 * 1024 * 5; // 5 mb
